import { render, staticRenderFns } from "./depositHistory.vue?vue&type=template&id=2ec41658&scoped=true&"
import script from "./depositHistory.vue?vue&type=script&lang=js&"
export * from "./depositHistory.vue?vue&type=script&lang=js&"
import style0 from "./depositHistory.vue?vue&type=style&index=0&id=2ec41658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec41658",
  null
  
)

export default component.exports